export default __webpack_public_path__ + "static/media/code-date.8866ca8d.png";